import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
} from '@angular/core';
import { Subject } from 'rxjs';
import { Hostel } from '@app/services/api/api.service';

@Component({
  selector: 'app-bottom-sheet',
  templateUrl: './bottom-sheet.component.html',
  styleUrls: ['./bottom-sheet.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [],
})
export class BottomSheetComponent {
  @Output()
  cardClicked = new EventEmitter<void>();

  @Input()
  public hostel: Hostel;

  @Input()
  public data: any;

  @Input()
  template: TemplateRef<any> | null = null;

  private destroyed = new Subject<void>();
  isOpen = false;

  constructor(private readonly cdr: ChangeDetectorRef) {}

  ngOnInit() {
    this.data = {
      title: 'Reviews',
    };
  }

  open() {
    this.isOpen = true;
    this.cdr.markForCheck();
  }

  close() {
    this.isOpen = false;
    this.cdr.markForCheck();
  }
}
